module.exports = __webpack_public_path__ + "media/images/file-icons/64/008-archive-8094b7ac62872d8d6b59b3662986d33f.png";